import { VConsolePlugin } from 'vconsole'
const DEFAULT_REDIRECT_URL = 'http://192.168.48.29:5173/'
const REDIRECT_URL_KEY = 'vc_replace_url'

export default class VcEnvPlugin extends VConsolePlugin {
  constructor() {
    super('env', '工具')
    this._timer = null
    this._envIndex = 0
    this._envPairs = []
  }

  onRenderTab(callback) {
    callback(this._getHtml())
  }

  onShow() {
    // 进入面板时立即刷新一次，并每秒动态刷新时间与当前URL
    this._prepareEnvPairs()
    this._renderAllEnvList()
    this._refresh()
    if (this._timer) clearInterval(this._timer)
    this._timer = setInterval(() => {
      this._refresh()
    }, 1000)
  }

  onHide() {
    // 离开面板时停止定时器
    if (this._timer) {
      clearInterval(this._timer)
      this._timer = null
    }
  }

  onAddTool(callback) {
    const tools = [
      {
        name: '清缓存',
        onClick: () => {
          try {
            localStorage.clear()
            sessionStorage.clear()
            location.reload()
          } catch (e) {
            alert('清除缓存失败：' + e?.message)
          }
        }
      },
      {
        name: '切换vconsole',
        onClick: () => {
          const on = localStorage.getItem('vconsole') === '1'
          localStorage.setItem('vconsole', on ? '0' : '1')
          location.reload()
        }
      },
      {
        name: '设置跳转URL',
        onClick: () => {
          const input = prompt('请输入跳转URL（留空则使用默认）', localStorage.getItem(REDIRECT_URL_KEY) || DEFAULT_REDIRECT_URL)
          if (input) {
            localStorage.setItem(REDIRECT_URL_KEY, input)
          } else {
            localStorage.removeItem(REDIRECT_URL_KEY)
          }
          // 设置后立即刷新显示的当前URL
          this._refresh()
        }
      },
      {
        name: '跳转URL',
        onClick: () => {
          const url = localStorage.getItem(REDIRECT_URL_KEY) || DEFAULT_REDIRECT_URL
          try {
            localStorage.setItem(REDIRECT_URL_KEY, url)
          } catch (e) {
            // ignore
          }
          location.replace(url)
        }
      }
    ]
    callback(tools)
  }

  _getHtml() {
    return `
      <div id="vc-env" class="vc-section">
        <div class="vc-section-title">环境信息</div>
        <div id="vc-env-list"></div>
        <div id="vc-env-location">location：${location.href}</div>
        <div>UserAgent：${navigator.userAgent}</div>
        <div>时间：<span id="vc-env-time">${new Date().toLocaleString()}</span></div>
        <div>跳转URL（当前配置）：<span id="vc-env-url">${localStorage.getItem(REDIRECT_URL_KEY) || DEFAULT_REDIRECT_URL}</span></div>
      </div>
    `
  }

  _refresh() {
    const timeEl = document.querySelector('#vc-env-time')
    if (timeEl) {
      timeEl.textContent = new Date().toLocaleString()
    }
    const urlEl = document.querySelector('#vc-env-url')
    if (urlEl) {
      urlEl.textContent = localStorage.getItem(REDIRECT_URL_KEY) || DEFAULT_REDIRECT_URL
    }
    const locationEl = document.querySelector('#vc-env-location')
    if (locationEl) {
      locationEl.textContent = 'location：' + location.href
    }
    // 时间与URL刷新后，再逐步追加环境变量
  }

  _safeEnv() {
    try {
      if (import.meta && import.meta.env) return import.meta.env
    } catch (e) {}
    try {
      if (typeof process !== 'undefined' && process.env) return process.env
    } catch (e) {}
    return {}
  }

  _prepareEnvPairs() {
    const envObj = this._safeEnv() || {}
    const entries = Object.entries(envObj)
      .filter(([k]) => k && typeof k === 'string')
      .sort(([a], [b]) => a.localeCompare(b))
    this._envPairs = entries
    this._envIndex = 0
    const listEl = document.querySelector('#vc-env-list')
    if (listEl) listEl.innerHTML = ''
  }

  _renderAllEnvList() {
    const listEl = document.querySelector('#vc-env-list')
    if (!listEl) return
    let html = ''
    for (let i = 0; i < this._envPairs.length; i++) {
      const [k, v] = this._envPairs[i]
      html += `<div class="vc-row">${k}=${String(v)}</div>`
    }
    listEl.innerHTML = html
  }
}